import "./track.css";

export type Station = { title: string; text: string };

type StationTrackProps = {
  items: Station[];
  /** "light" for paper backgrounds, "dark" for navy sections. */
  tone?: "light" | "dark";
  /** Show the coral dot sliding along the track (desktop only). */
  running?: boolean;
  /** Title size variant. */
  size?: "md" | "lg";
  /** Mark the last station with a ↺ to suggest the loop continues. */
  loops?: boolean;
};

/**
 * Horizontal "track" of numbered stations — the brand's signature pattern.
 * Each station sits on a segment of a thick navy bar with a dotted centre line;
 * the last segment is coral. On narrow screens the stations stack.
 */
const StationTrack = ({
  items,
  tone = "light",
  running = true,
  size = "md",
  loops = false,
}: StationTrackProps) => (
  <div className={`is-stations is-stations--${tone} is-stations--${size}`}>
    {running && <span className="is-stations__dot" aria-hidden="true" />}
    <ol className="is-stations__list">
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <li key={item.title} className="is-station">
            <div className={"is-track-bar" + (last ? " is-track-bar--accent" : "")}>
              <span className="is-track-bar__num">{String(i + 1).padStart(2, "0")}</span>
            </div>
            <div className="is-station__body">
              <h3 className="is-station__title">
                {item.title}
                {last && loops ? " ↺" : ""}
              </h3>
              <p className="is-station__text">{item.text}</p>
            </div>
          </li>
        );
      })}
    </ol>
  </div>
);

export default StationTrack;
